/**
 *
 * Asynchronously loads the component for PublishingDistributionPage
 *
 */
import Loadable from 'react-loadable';
export default Loadable({
    loader: function () {
        return import(/* webpackChunkName: 'PublishingDistributionPage' */ './index');
    },
    loading: function (props) {
        if (props.error) {
            console.error(props.error);
        }
        return null;
    },
});
